import type { IModuleSummary } from '@platform/core/types';

/** Кількість записів модуля для меню й плиток: головна таблиця модуля (або вказаний тип запису — ярлик «модуль/тип»). */
export function moduleCount(module: IModuleSummary | undefined, recordType?: string): number | undefined {
  if (!module) return undefined;
  const rt = recordType ? module.recordTypes.find((r) => r.key === recordType) : module.recordTypes.find((r) => r.main) ?? module.recordTypes[0];
  return rt?.recordCount;
}
